import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { ReportData } from '../models/report-data.model';
import { Constants } from './constants.util';

@Injectable()
export class MiscUtil {	 
    static checkArray(array: any[]): boolean {
        return Array.isArray(array) && !!array.length;
    }

    static areArraysEqual(array1: any[], array2: any[]): boolean {
        if (!this.checkArray(array1) || !this.checkArray(array2) || array1.length != array2.length) {
            return false;
        }

        let areEqual = true;

        for (let counter = 0; counter < array1.length; counter++) {
            if (array1[counter] != array2[counter]) {
                areEqual = false;
            }
        }

        return areEqual;
    }

  static getDataFilteredByDataSetName(reportData: ReportData, name: string = 'series') { 
      if(!reportData)
        return [];
      let dataSets = reportData.dataSets.filter(
        x=> x.name === name);
       
      return dataSets && dataSets[0] ? dataSets[0].dataSet : [];  
    };

    static checkNumber(value: number): boolean {
        return value != null && value != undefined && value.toString().trim() != "";
    }

    static formatGridValue (value: any, decimalPlaces = 2): string {
        //We want to display infinity and nulls as a dash
        if(value == Infinity || value == '∞' || value == 'NaN' || value == null)
            return "-";

        let num = Number(value);

        if(isNaN(num))
            return value;
        
        // Set the decimal precision.
        return num.toFixed(decimalPlaces);
    }

    static getShiftBlockDescription(startHour: number, endHour: number): string {
        let startHourDescription = this.militaryTimeToStandardTimeDescription(startHour);

        if (startHourDescription == "") {
            return "";
        }

        let endHourDescription = this.militaryTimeToStandardTimeDescription(endHour);

        return startHourDescription + " - " + endHourDescription;
    }    

    static isValidNonNegativeNumber(value: number) {
        return this.isValidNumber(value) && value >= 0;
    }

    static isValidNumber(value: number): boolean {
        return !!value || value === 0;
    }

    static isValidPositiveNumber(value: number): boolean{
        return this.isValidNumber(value) && value > 0;
    }

    static dateStartHourToFacilityTimeFormat(date:string, startHour:number): string{
        var dateString = moment(date).format(Constants.DateFormat);
        let hoursToAdd = startHour < 10 ? "0" + startHour : startHour;
        dateString += "T" + hoursToAdd + ":00:00";
        return dateString;
    }

    static militaryTimeToStandardTimeDescription(hour: number): string {
        if (!this.checkNumber(hour)) {
            return "";
        }

        switch(hour) {
            case 0:
            case 24:
                return "12:00 AM";
            case 12:
                return "12:00 PM";
            default:                
                if (hour < 12) {
                    return hour.toString() + ":00 AM";
                }
                else {
                    return (hour - 12).toString() + ":00 PM"
                }
        }
    }

    // Delay the execution of a function for a specified number of milliseconds.
	static DelayFunctionExecution(func: () => void, wait: number): Function
	{
		let h: number;
		return () => {
			clearTimeout(h);
			h = window.setTimeout(() => func(), wait);
		};
	}
}